import React from 'react';
import { RadioButton } from 'primereact/radiobutton';
import styles from './accommodation-blocking-type.module.scss';

export type IAccommodationBlockingType = 'checkIn' | 'checkOut' | 'stay';

interface IAccommodationBlockingTypeProperties {
  value: IAccommodationBlockingType;
  onChange: (value: IAccommodationBlockingType) => void;
}

const TYPE_OPTIONS: { label: string; value: IAccommodationBlockingType }[] = [
  { label: 'Check In', value: 'checkIn' },
  { label: 'Check Out', value: 'checkOut' },
  { label: 'Stay', value: 'stay' },
];

function AccommodationBlockingType({ value, onChange }: IAccommodationBlockingTypeProperties) {
  return (
    <div className={styles.radioGroup}>
      {TYPE_OPTIONS.map((option) => {
        const inputId = `accommodationBlockingType-${option.value}`;
        return (
          <div key={option.value} className={styles.radioOption}>
            <RadioButton
              inputId={inputId}
              name="accommodationBlockingType"
              value={option.value}
              onChange={(event) => onChange(event.value as IAccommodationBlockingType)}
              checked={value === option.value}
            />
            <label htmlFor={inputId}>{option.label}</label>
          </div>
        );
      })}
    </div>
  );
}

export default AccommodationBlockingType;
